import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import Tabs from './Tabs/Tabs';
import ReactToPrint from "react-to-print";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

class Result extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: [],
        };
    }
    componentWillMount() {
        let customerSegmentData = {
            projectId: this.props.projectId,
            type: 'segmentation'
        }
        let competeData = {
            projectId: this.props.projectId,
            type: 'compete'
        }
        let positioningStatementData = {
            projectId: this.props.projectId,
            type: 'positioning'
        }
        let cometitorsGroups = {
            projectId: this.props.projectId,
            type: 'competitors'
        }
        let ValueProposition = {
            projectId: this.props.projectId,
            type: 'valueProposition'
        }
        let pricingValue = {
            projectId: this.props.projectId,
            type: 'pricingValue'
        }
        let challengeData = {
            type: "challenge",
            projectId: this.props.projectId,
        }
        this.props.getChallengeStatements(challengeData)
        this.props.getPricingValue(pricingValue)
        this.props.getPositioningStatement(positioningStatementData);
        this.props.getCompete(competeData);
        this.props.getCustomerSegment(customerSegmentData);
        this.props.getCompetitorsGroups(cometitorsGroups)
        this.props.getValueProposition(ValueProposition)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.pricingValue.pricingValueFetched && nextProps.pricingValue.pricingValueData.Items.length > 0 && this.state.tabs.length === 0) {
            this.setState({
                tabs: nextProps.pricingValue.pricingValueData.Items[0].competitorsPrice
            })
        }
    }
    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }
    downloadPDF = () => {
        let print = document.getElementById('print');
        html2canvas(print)
            .then((canvas) => {
                let wid
                let hgt
                const imgData = canvas.toDataURL('image/png', wid = canvas.width, hgt = canvas.height);
                let hratio = hgt/wid
                let pdf = new jsPDF('p','pt','a4');
                let width = pdf.internal.pageSize.width;
                let height = width * hratio
                pdf.addImage(imgData,'JPEG',0,0, width, height);
                pdf.save('pricing-value.pdf');
            });
    };

    render() {
        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step-bar'>
                        <div className='step step-two arrow-step '>
                            <p>Step 1</p>
                        </div>
                        <div className='step step-two arrow-step active-step'>
                            <p>Result</p>
                        </div>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>Pricing Perceived Value</h5>
                      </div>
                    </div>
                    {(this.props.compete.competeFetching || !this.props.positioningStatement.getPositioningStatementFetched || this.props.compete.competitorsGroupsFetching || !this.props.valueProposition.valuePropositionFetched || !this.props.compete.customerSegmentFetched || !this.props.pricingValue.pricingValueFetched) && this.elementInfiniteLoad()}
                    {!this.props.compete.competeFetching && this.props.positioningStatement.getPositioningStatementFetched && !this.props.compete.competitorsGroupsFetching && this.props.valueProposition.valuePropositionFetched && this.props.compete.customerSegmentFetched && this.props.challengeStatement.getChallengeStatementData.Items && this.props.competitiveAnalysis.competitorsGroupsData.Items &&
                        <div className='row'>

                            <div className="col-md-12">
                                <div className='card'  id="print" ref={el => (this.componentRef = el)}>
                                    <div className="card-header">
                                        <h5>Results</h5>
                                    </div>
                                    <div className='card-body'>
                                        <Tabs
                                            tabs={this.state.tabs}
                                            compete={this.props.compete}
                                            challengeStatement={this.props.challengeStatement}
                                            competitiveAnalysis={this.props.competitiveAnalysis}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        {/* <div className='btn btn-success' onClick={() => this.onNextButtonClick()}>Next</div> */}
                                        <Link to='/toolkit' className='btn btn-success'> Done </Link>
                                        <div className='btn empty-btn default' onClick={this.downloadPDF}>Save PDF</div>
                                        <ReactToPrint
                                            trigger={() => <a className='btn empty-btn default' href="#">Print</a>}
                                            content={() => this.componentRef}
                                        />
                                        <div className='btn empty-btn default' onClick={() => this.props.groupStateBack()}>Back</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default (Result);



// WEBPACK FOOTER //
// ./src/components/PricingValueComponent/Results/Results.jsx